import Swal from "sweetalert2";
import { BiChevronDown } from "react-icons/bi";

import Dropdown from "../../../components/Dropdown";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";
import {
  changeEmployee,
  Employee,
  resendInviteEmployee,
} from "../../../store/employee";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import EmployeeInfo from "./detail/index";
import AssingBrand from "../../../components/assingBrand/AssingBrand";
import { useEffect } from "react";
import AddRoles from "./roles";

interface Props {
  employee: Employee;
  index: number;
}
const bgColor = [
  "#a2e4e5",
  "#f5ecbb",
  "#aff3ad",
  "#f4b5f9",
  "#ebc7d6",
  "#92a8d1",
  "#b9dee6",
  "#fae1e7",
  "#a1c5c1",
  "#f7cac9",
];
const lColor = [
  "#92a8d1",
  "#FFCCCC",
  "#FFFFCC",
  "#f5ecbb",
  "#92a8d1",
  "#b9dee6",
  "#a1c5c1",
  "#a1c5c1",
  "#FFCC99",
  "#92a8d1",
];

const Oneempleyee = ({ employee, index }: Props) => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.employee);
  const { skills } = useAppSelector((state) => state.user);
  const { isShown: isShowProfile, toggle: ToggleEmployeeProfile } = useModal();
  const { isShown: isModalShown, toggle: ToggleModal } = useModal();
  const { isShown: isRolesShown, toggle: ToggleModalRoles } = useModal();

  const resend = () => {
    dispatch(resendInviteEmployee({ id_encrypted: employee.id_encrypted }));
  };

  const modalStatus = (data: any) => {
    Swal.fire({
      text:
        employee.status === 1
          ? "Do you want to deactivate this employee?"
          : "Do you want to activate this employee?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f03361",
      cancelButtonColor: "#464E5F",
      confirmButtonText: "Yes, confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(changeEmployee(data || { id_encrypted: "", status: 0 }));
      }
    });
  };

  useEffect(() => {
    if (status === "assingBrands_success") {
      Swal.fire({ title: "Brands correctly assigned", icon: "success" }).then(
        (isConfirmend) => {
          if (isConfirmend.isConfirmed || isConfirmend.dismiss) {
            ToggleModal();
          }
        },
      );
    }
    return () => {
      if (status === "assingBrands_success") {
        Swal.fire({ title: "Brands correctly assigned", icon: "success" }).then(
          (isConfirmend) => {
            if (isConfirmend.isConfirmed || isConfirmend.dismiss) {
              ToggleModal();
            }
          },
        );
      }
    };
  }, [status]);

  const Optiosn = (
    <div className="c-list-options">
      {skills.includes("public.users.employees.edit") ||
      skills.includes("super.admin") ||
      skills.includes("public.employee.users.manager") ? (
        <span
          className="c-list-options__item"
          onClick={() => ToggleEmployeeProfile()}
        >
          Edit
        </span>
      ) : null}
      {skills.includes("public.users.employees.update") ||
      skills.includes("super.admin") ||
      skills.includes("admin.employee.send.invitations") ||
      skills.includes("admin.guardian.users.create") ||
      skills.includes("admin.guardian.roles.list") ? (
        <>
          {(skills.includes("public.users.employees.update") ||
            skills.includes("super.admin") ||
            skills.includes("admin.employee.send.invitations")) && (
            <span className="c-list-options__item" onClick={() => resend()}>
              {employee.last_login ? "Resend Password" : "Send Invite"}
            </span>
          )}
          {(skills.includes("public.users.employees.update") ||
            skills.includes("super.admin") ||
            skills.includes("admin.guardian.users.create")) && (
            <span
              className="c-list-options__item"
              onClick={() => ToggleModal()}
            >
              Assign Brands
            </span>
          )}
          {(skills.includes("public.users.employees.update") ||
            skills.includes("super.admin") ||
            skills.includes("admin.guardian.roles.list")) && (
            <span
              className="c-list-options__item"
              onClick={() => ToggleModalRoles()}
            >
              Edit Roles
            </span>
          )}
        </>
      ) : null}
      {skills.includes("public.users.employees.soft-delete") ||
      skills.includes("super.admin") ||
      skills?.includes("public.employee.users.manager") ? (
        <>
          {employee.status === 1 ? (
            <span
              className="c-list-options__item"
              onClick={() =>
                // toggle({
                //   id_encrypted: employee.id_encrypted,
                //   status: 0,
                // })
                modalStatus({
                  id_encrypted: employee.id_encrypted,
                  status: 0,
                })
              }
            >
              Deactivate
            </span>
          ) : (
            <span
              className="c-list-options__item"
              onClick={() =>
                // toggle({
                //   id_encrypted: employee.id_encrypted,
                //   status: 1,
                // })
                modalStatus({
                  id_encrypted: employee.id_encrypted,
                  status: 1,
                })
              }
            >
              Activate
            </span>
          )}
        </>
      ) : null}
    </div>
  );
  return (
    <>
      <Modal isActive={isShowProfile} clouse={ToggleEmployeeProfile}>
        <EmployeeInfo id={employee.id_encrypted} isShown={isShowProfile} />
      </Modal>
      <Modal
        isActive={isModalShown}
        clouse={ToggleModal}
        title="Assing Brands"
        key={employee.id_encrypted}
      >
        <AssingBrand
          isShown={isModalShown}
          id_user={employee.id_encrypted}
          employeeBrands={employee.brands}
        />
      </Modal>
      <Modal
        isActive={isRolesShown}
        clouse={ToggleModalRoles}
        title="Edit Roles"
        key={employee.id}
      >
        <AddRoles
          isShown={isRolesShown}
          toggle={ToggleModalRoles}
          id={employee.id_encrypted}
        />
      </Modal>
      <tr>
        {/*  <td className="c-table__trbody"><input type="checkbox" id="cbox1" value="first_checkbox" /></td> */}
        <td className="c-table__trbody">
          <div className="c-avatar-user">
            {employee.extra.avatar ? (
              <img
                className="c-avatar-user__avatar"
                src={employee.extra.avatar}
                alt="avatar"
              />
            ) : (
              <div
                className="c-avatar-user__default"
                style={{
                  backgroundColor: `${bgColor[index]}`,
                  color: `${lColor[index]}`,
                }}
              >
                {employee?.name.trim().charAt(0).toUpperCase()}
              </div>
            )}
            <div className="c-avatar-user__box-data">
              <span className="c-avatar-user__name">{employee?.name}</span>
              <span className="c-avatar-user__email">{employee?.email}</span>
            </div>
          </div>
        </td>
        <td className="c-table__trbody">
          {employee.status === 1 ? (
            <span className="c-table__status">Active</span>
          ) : (
            <span className="c-table__status c-table__status--desactive">
              Inactive
            </span>
          )}
        </td>
        <td className="c-table__trbody">{employee?.employee.employee_code}</td>
        {/* <td className="c-table__trbody">
          {employee.brands &&
            employee.brands.map((brand) => (
              <img
                src={brand.pin_logo}
                alt={brand.name}
                width="30px"
                height="30px"
                style={{ marginRight: "5px" }}
              />
            ))}
        </td> */}
        <td className="c-table__trbody">{employee?.employee.division_brand}</td>
        <td className="c-table__trbody">
          <Dropdown overlay={Optiosn} placement="bottom-end" margin={0}>
            <button className="c-table__actions">
              Actions <BiChevronDown />
            </button>
          </Dropdown>
        </td>
      </tr>
    </>
  );
};

export default Oneempleyee;
